export default {
      id: "status_clock-usage",
      viewBox: "0 0 20 20",
      url: __webpack_public_path__ + "img/icons.a12b6041.svg#status_clock",
      toString: function () {
        return this.url;
      }
    }